import React, { Fragment, useEffect, useRef, useState } from 'react';
import { Alert, Button, Modal } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { LoadingComponent } from 'recupero-comunes';
import { ConsultaInformePenalComponent } from 'defcol-caso-general';
import Formulario from './formulario';
import { serviceGetRevisionInformePenal, servicePostRevisaInformePenal } from '../../../api/api-revisa-informe-penal';
import { MSG_ERROR_CARGA } from './constantes';

// RG-580 — «Revisión de Informe - Implicado» (tareas WFL 91 «Visar Informe Inicial-Implicado» y 94 «Visar Actualización
// Informe-Implicado»). Se abre desde el engranaje de «Gestión Tareas Pendientes». «Guardar Revisión» envía la decisión, los
// montos y el comentario al lambda defensa-fnc-revisa-informe-penal; `onTareaGestionada` avisa a la grilla cuando termina bien.
const RevisarInformePenal = ({ showModal, setShowModal, onTareaGestionada }) => {

    const [loading, setLoading] = useState(false);
    const [datos, setDatos] = useState(null);
    const [mensaje, setMensaje] = useState('');
    const [showHistorial, setShowHistorial] = useState(false);

    const data_encargado = useSelector((state) => state.encargadoCompaniaReducer);
    const { llaves } = data_encargado;

    // Número de la última petición: una respuesta tardía de una apertura anterior (o de un modal ya cerrado) se descarta.
    const peticion = useRef(0);

    useEffect(() => {
        if (showModal && llaves?.idCaso) {
            cargarDatos();
        } else {
            peticion.current += 1;
            setDatos(null);
            setMensaje(showModal ? MSG_ERROR_CARGA : '');
            setLoading(false);
        }
    }, [showModal]);

    const cargarDatos = async () => {
        const miPeticion = peticion.current + 1;
        peticion.current = miPeticion;
        setLoading(true);
        setDatos(null);
        setMensaje('');
        try {
            const q = Buffer.from(JSON.stringify({ modo: 'revision', idCaso: llaves.idCaso })).toString('base64');
            const objeto = await serviceGetRevisionInformePenal(q);
            if (miPeticion !== peticion.current) return;
            setDatos(objeto);
        } catch (error) {
            if (miPeticion !== peticion.current) return;
            setMensaje(error && error.message ? error.message : MSG_ERROR_CARGA);
        } finally {
            if (miPeticion === peticion.current) setLoading(false);
        }
    };

    const handleClose = () => setShowModal(false);

    return (
        <Fragment>
            <Modal show={showModal} onHide={handleClose} size='xl' backdrop='static' scrollable>
                <LoadingComponent show={loading} />
                {datos && (
                    <Formulario
                        datos={datos}
                        onVolver={handleClose}
                        onHistorial={() => setShowHistorial(true)}
                        onGuardarRevision={servicePostRevisaInformePenal}
                        onTareaGestionada={onTareaGestionada}
                    />
                )}
                {!datos && mensaje && (
                    <Modal.Body>
                        <Alert variant='warning' className='mb-2'>{mensaje}</Alert>
                        <div className='d-flex justify-content-end'>
                            <Button variant='outline-info' onClick={handleClose}>Volver</Button>
                        </div>
                    </Modal.Body>
                )}
            </Modal>

            {datos && (
                <ConsultaInformePenalComponent
                    idCaso={llaves?.idCaso}
                    idOrgCaso={llaves?.idOrgCaso}
                    tipoGestion={datos.caso?.codTipoGestion}
                    showModal={showHistorial}
                    setShowModal={setShowHistorial}
                />
            )}
        </Fragment>
    );
};

export default RevisarInformePenal;
